import {dateTimeStringFromApiToDate} from "../../../index";
import {UddannelseTypeEnum} from "./uddannelseTypeEnum";
import {OverlapCompareModel} from "../OverlapCompareModel";
import {ForloebKladdeResponseModel} from "../../../services/api/forloeb/uddannelsesstedForloebKladderResponseModel";
import StringBuilder from "../stringBuilder/stringBuilder";
import {
    appendGenerelForloebKladdeOverviewPillData
} from "../stringBuilder/customFunctions/appendGenerelForloebKladdeOverviewPillData";

export class ForloebKladdeModel implements OverlapCompareModel {

    public static FromResponseModel(responseModel: ForloebKladdeResponseModel): ForloebKladdeModel {
        const model = new ForloebKladdeModel();
        model.stillingId = responseModel.stillingId;
        model.forloebKladdeId = responseModel.forloebKladdeId;
        model.attestationForTidInfotekst = responseModel.attestationForTidInfotekst;
        model.uddannelseType = responseModel.uddannelseType;
        model.specialeNavn = responseModel.specialeNavn;
        model.startDate = dateTimeStringFromApiToDate(responseModel.startDato);
        model.endDate = dateTimeStringFromApiToDate(responseModel.slutDato);
        model.compareId = responseModel.stillingId;
        model.regionNavn = responseModel.regionNavn;
        model.stillingNummer = responseModel.stillingNummer;
        model.stedInfo = responseModel.stedInfo;
        model.kommerFraVu = responseModel.kommerFraVu;
        model.delforloebNummer = responseModel.delforloebNummer;
        model.ubesatEfterRundeLukning = responseModel.ubesatEfterRundeLukning;
        model.rundeNavn = responseModel.rundeNavn;
        return model;
    }

    stillingId: string;
    forloebKladdeId: string;
    uddannelseType: UddannelseTypeEnum;
    specialeNavn: string;
    startDate: Date;
    endDate: Date;
    compareId: string;
    regionNavn: string;
    stillingNummer: string;
    stedInfo: string;
    attestationForTidInfotekst: string;
    kommerFraVu: boolean;

    ubesatEfterRundeLukning: boolean;
    delforloebNummer: string;
    rundeNavn: string;

    public ToDataString = (separator = '<br/>') => {
        const tooltipInfo = new StringBuilder("", separator);

        return appendGenerelForloebKladdeOverviewPillData(
            this.regionNavn,
            this.specialeNavn,
            this.stedInfo,
            this.stillingNummer,
            this.uddannelseType,
            this.startDate,
            this.endDate,
            tooltipInfo
        ).toString();
    }
}

